import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {HashRouter } from 'react-router-dom';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import "@meridian/tokens/base/font/amazon-ember.css";
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en'
import {IntlProvider} from "react-intl";
import {getLocale, getMessages} from "./components/handler/LocaleHandler";

addLocaleData(en)

ReactDOM.render((
    <IntlProvider locale={getLocale()} messages={getMessages()}>
    <HashRouter>
        <App/>
    </HashRouter>
    </IntlProvider>
), document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


// WEBPACK FOOTER //
// ./src/index.js